var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "net-toolbox", class: { "is-scanning": _vm.scanning } },
    [
      _c("div", { staticClass: "net-header" }, [
        _c("div", { staticClass: "net-header-left" }, [
          _c(
            "div",
            { staticClass: "net-header-icon" },
            [
              _c("v-icon", { attrs: { size: "18", color: "white" } }, [
                _vm._v("mdi-lan"),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "net-header-text" }, [
            _c("span", { staticClass: "net-title" }, [
              _vm._v(_vm._s(_vm.$t("yealink-net-title"))),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "net-header-right" },
          [
            _vm.isDone
              ? _c(
                  "span",
                  {
                    staticClass: "net-fresh",
                    attrs: { title: _vm.freshTitle },
                  },
                  [
                    _c(
                      "v-icon",
                      {
                        staticClass: "mr-1",
                        attrs: { "x-small": "", color: "#16a34a" },
                      },
                      [_vm._v("mdi-check-decagram")]
                    ),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("yealink-net-fresh", {
                            time: _vm.formatTime(_vm.scan.finishedAt),
                          })
                        ) +
                        " "
                    ),
                    _vm.scan.historyEntryType
                      ? _c(
                          "v-icon",
                          {
                            staticClass: "ml-1",
                            attrs: {
                              "x-small": "",
                              color:
                                _vm.scan.historyEntryType === "detected"
                                  ? "#f59e0b"
                                  : "#00acc1",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.scan.historyEntryType === "detected"
                                    ? "mdi-source-branch"
                                    : "mdi-content-save-check"
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "v-btn",
              {
                staticClass: "net-header-btn",
                attrs: { small: "", text: "", disabled: _vm.scanning },
                on: { click: _vm.runScan },
              },
              [
                _c("v-icon", { attrs: { small: "", left: "" } }, [
                  _vm._v("mdi-radar"),
                ]),
                _vm._v(" " + _vm._s(_vm.$t("yealink-net-rescan")) + " "),
              ],
              1
            ),
            _c(
              "v-btn",
              {
                staticClass: "net-header-btn",
                class: { "is-active": _vm.historyOpen },
                attrs: { small: "", text: "" },
                on: {
                  click: function ($event) {
                    _vm.historyOpen = !_vm.historyOpen
                    _vm.collapsed = false
                  },
                },
              },
              [
                _c("v-icon", { attrs: { small: "", left: "" } }, [
                  _vm._v("mdi-history"),
                ]),
                _vm._v(" " + _vm._s(_vm.$t("yealink-net-history")) + " "),
                _vm.history.entryCount
                  ? _c("span", { staticClass: "net-count-pill" }, [
                      _vm._v(_vm._s(_vm.history.entryCount)),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "v-btn",
              {
                staticClass: "net-collapse-btn",
                attrs: { icon: "", small: "" },
                on: {
                  click: function ($event) {
                    _vm.collapsed = !_vm.collapsed
                  },
                },
              },
              [
                _c("v-icon", { attrs: { small: "" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.collapsed ? "mdi-chevron-down" : "mdi-chevron-up"
                    )
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm.collapsed && _vm.isDone
        ? _c(
            "div",
            {
              staticClass: "net-collapsed-strip",
              on: {
                click: function ($event) {
                  _vm.collapsed = false
                },
              },
            },
            [
              _c(
                "span",
                {
                  staticClass: "net-mini-badge",
                  style: {
                    "--badge-color": _vm.transportColor(_vm.summary.transport),
                  },
                },
                [_vm._v(_vm._s(_vm.transportLabel(_vm.summary.transport)))]
              ),
              _c(
                "span",
                {
                  staticClass: "net-mini-badge",
                  style: { "--badge-color": _vm.stunColor(_vm.summary.stun) },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("yealink-net-stun")) +
                      " " +
                      _vm._s(_vm.stunLabel(_vm.summary.stun))
                  ),
                ]
              ),
              _c("span", { staticClass: "net-collapsed-text" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("yealink-net-phones-of", {
                      count: _vm.summary.scanned,
                      total: _vm.summary.total,
                    })
                  )
                ),
              ]),
              _vm.attention.length
                ? _c(
                    "span",
                    { staticClass: "net-collapsed-warn" },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "mr-1",
                          attrs: { "x-small": "", color: "#f59e0b" },
                        },
                        [_vm._v("mdi-alert-circle")]
                      ),
                      _vm._v(_vm._s(_vm.attention.length) + " "),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm.scanning || (!_vm.scan && !_vm.scanError)
        ? _c(
            "div",
            { staticClass: "net-scanning" },
            [
              _c("v-progress-linear", {
                attrs: {
                  value: _vm.progress,
                  indeterminate: !_vm.scan || !_vm.scan.total,
                  height: "6",
                  rounded: "",
                  color: "#00acc1",
                  "background-color": "rgba(0, 172, 193, 0.12)",
                },
              }),
              _c(
                "div",
                { staticClass: "net-scanning-text" },
                [
                  _c("v-progress-circular", {
                    staticClass: "mr-2",
                    attrs: {
                      indeterminate: "",
                      size: "14",
                      width: "2",
                      color: "#00acc1",
                    },
                  }),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("yealink-net-scanning", {
                          completed: _vm.scan ? _vm.scan.completed : 0,
                          total: _vm.scan ? _vm.scan.total : "…",
                        })
                      )
                    ),
                  ]),
                  _c("span", { staticClass: "net-scanning-hint" }, [
                    _vm._v(_vm._s(_vm.$t("yealink-net-scanning-hint"))),
                  ]),
                ],
                1
              ),
              _vm.scan
                ? _c(
                    "div",
                    { staticClass: "net-scan-pills" },
                    _vm._l(_vm.scan.devices, function (d) {
                      return _c(
                        "span",
                        {
                          key: d.deviceId,
                          staticClass: "net-scan-pill",
                          class: `state-${d.state}`,
                          attrs: { title: d.name || d.mac },
                        },
                        [
                          d.state === "pending"
                            ? _c("v-progress-circular", {
                                attrs: {
                                  indeterminate: "",
                                  size: "10",
                                  width: "2",
                                  color: "#00acc1",
                                },
                              })
                            : _c(
                                "v-icon",
                                {
                                  attrs: {
                                    "x-small": "",
                                    color: _vm.stateColor(d.state),
                                  },
                                },
                                [_vm._v(_vm._s(_vm.stateIcon(d.state)))]
                              ),
                          _c("span", { staticClass: "net-scan-pill-name" }, [
                            _vm._v(_vm._s(d.name || d.mac)),
                          ]),
                          d.state === "ok"
                            ? _c(
                                "span",
                                {
                                  staticClass: "net-scan-pill-value",
                                  style: {
                                    color: _vm.transportColor(d.transport),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.transportLabel(d.transport))
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm.scanError
        ? _c(
            "v-alert",
            {
              staticClass: "ma-3 mb-2",
              attrs: { type: "error", outlined: "", dense: "" },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-center justify-space-between flex-wrap",
                },
                [
                  _c("span", { staticClass: "text-body-2" }, [
                    _vm._v(_vm._s(_vm.scanError)),
                  ]),
                  _c(
                    "v-btn",
                    {
                      attrs: { small: "", text: "", color: "error" },
                      on: { click: _vm.runScan },
                    },
                    [
                      _c("v-icon", { attrs: { small: "", left: "" } }, [
                        _vm._v("mdi-refresh"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("yealink-net-rescan")) + " "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : !_vm.collapsed
        ? _c(
            "div",
            { staticClass: "net-body" },
            [
              _c("div", { staticClass: "net-card" }, [
                _c("div", { staticClass: "net-state" }, [
                  _c("div", { staticClass: "net-tiles" }, [
                    _c(
                      "div",
                      {
                        staticClass: "net-tile",
                        style: {
                          "--tile-color": _vm.transportColor(
                            _vm.summary.transport
                          ),
                        },
                      },
                      [
                        _c("span", { staticClass: "net-tile-label" }, [
                          _vm._v(_vm._s(_vm.$t("yealink-net-transport"))),
                        ]),
                        _c("span", { staticClass: "net-tile-value" }, [
                          _vm._v(
                            _vm._s(_vm.transportLabel(_vm.summary.transport))
                          ),
                        ]),
                        _c(
                          "span",
                          { staticClass: "net-tile-sub" },
                          [
                            _vm.summary.scanned
                              ? [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("yealink-net-phones-of", {
                                        count: _vm.dominantTransportCount,
                                        total: _vm.summary.scanned,
                                      })
                                    )
                                  ),
                                ]
                              : [
                                  _vm._v(
                                    _vm._s(_vm.$t("yealink-net-no-scanned"))
                                  ),
                                ],
                          ],
                          2
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "net-tile",
                        style: {
                          "--tile-color": _vm.stunColor(_vm.summary.stun),
                        },
                      },
                      [
                        _c("span", { staticClass: "net-tile-label" }, [
                          _vm._v(_vm._s(_vm.$t("yealink-net-stun"))),
                        ]),
                        _c("span", { staticClass: "net-tile-value" }, [
                          _vm._v(_vm._s(_vm.stunLabel(_vm.summary.stun))),
                        ]),
                        _c(
                          "span",
                          {
                            staticClass: "net-tile-sub",
                            attrs: {
                              title:
                                _vm.summary.stun === true
                                  ? _vm.stunServerDisplay
                                  : "",
                            },
                          },
                          [
                            _vm.summary.stun === "mixed"
                              ? [
                                  _vm._v(
                                    _vm._s(_vm.summary.stunOn) +
                                      " " +
                                      _vm._s(_vm.$t("yealink-net-stun-on")) +
                                      " · " +
                                      _vm._s(_vm.summary.stunOff) +
                                      " " +
                                      _vm._s(_vm.$t("yealink-net-stun-off"))
                                  ),
                                ]
                              : _vm.summary.stun === true
                              ? [_vm._v(_vm._s(_vm.stunServerDisplay))]
                              : _vm.summary.stun === false
                              ? [
                                  _vm._v(
                                    _vm._s(_vm.$t("yealink-net-stun-none"))
                                  ),
                                ]
                              : [_vm._v("—")],
                          ],
                          2
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "net-dist" }, [
                    _c(
                      "div",
                      { staticClass: "net-dist-bar" },
                      _vm._l(_vm.distribution, function (seg) {
                        return _c("span", {
                          key: seg.key,
                          staticClass: "net-dist-seg",
                          style: {
                            width: seg.percent + "%",
                            background: seg.color,
                          },
                          attrs: { title: `${seg.label}: ${seg.count}` },
                        })
                      }),
                      0
                    ),
                    _c(
                      "div",
                      { staticClass: "net-dist-legend" },
                      [
                        _vm._l(_vm.distribution, function (seg) {
                          return _c(
                            "span",
                            { key: seg.key, staticClass: "net-legend-item" },
                            [
                              _c("span", {
                                staticClass: "net-legend-dot",
                                style: { background: seg.color },
                              }),
                              _c("strong", [_vm._v(_vm._s(seg.count))]),
                              _vm._v(" " + _vm._s(seg.label) + " "),
                            ]
                          )
                        }),
                        _vm.attention.length
                          ? _c(
                              "button",
                              {
                                staticClass: "net-attention-toggle",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    _vm.attentionOpen = !_vm.attentionOpen
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-1",
                                    attrs: { "x-small": "", color: "#f59e0b" },
                                  },
                                  [_vm._v("mdi-alert-circle")]
                                ),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("yealink-net-attention-count", {
                                        count: _vm.attention.length,
                                      })
                                    ) +
                                    " "
                                ),
                                _c(
                                  "v-icon",
                                  {
                                    attrs: { "x-small": "", color: "#92400e" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.attentionOpen
                                          ? "mdi-chevron-up"
                                          : "mdi-chevron-down"
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                  _vm.attention.length && _vm.attentionOpen
                    ? _c(
                        "div",
                        { staticClass: "net-attention" },
                        _vm._l(_vm.attention, function (d) {
                          return _c(
                            "div",
                            {
                              key: d.deviceId,
                              staticClass: "net-attention-row",
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "net-attention-name" },
                                [_vm._v(_vm._s(d.name || d.mac))]
                              ),
                              _c(
                                "span",
                                { staticClass: "net-attention-reason" },
                                [_vm._v(_vm._s(d.reason))]
                              ),
                              _c(
                                "span",
                                { staticClass: "net-attention-actions" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        icon: "",
                                        "x-small": "",
                                        title: _vm.$t(
                                          "yealink-net-repush",
                                          _vm.repairTarget(d)
                                            ? {
                                                transport: _vm.transportLabel(
                                                  _vm.repairTarget(d).transport
                                                ),
                                                stun: _vm.stunLabel(
                                                  _vm.repairTarget(d).stun
                                                ),
                                              }
                                            : {}
                                        ),
                                        disabled:
                                          !_vm.repairTarget(d) ||
                                          _vm.repairingIds.includes(
                                            d.deviceId
                                          ) ||
                                          _vm.applying,
                                        loading: _vm.repairingIds.includes(
                                          d.deviceId
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.repairDevice(d)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            "x-small": "",
                                            color: "#00838f",
                                          },
                                        },
                                        [_vm._v("mdi-cloud-sync")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        icon: "",
                                        "x-small": "",
                                        title: _vm.$t("yealink-reboot"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit(
                                            "reboot-device",
                                            d.deviceId
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            "x-small": "",
                                            color: "#d97706",
                                          },
                                        },
                                        [_vm._v("mdi-restart")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "net-divider" }),
                _c("div", { staticClass: "net-switch" }, [
                  _c("div", { staticClass: "net-switch-row" }, [
                    _c("span", { staticClass: "net-switch-label" }, [
                      _vm._v(_vm._s(_vm.$t("yealink-net-switch-title"))),
                    ]),
                    _c(
                      "div",
                      { staticClass: "net-transport-options" },
                      [
                        _vm._l(_vm.visibleTransportOptions, function (opt) {
                          return _c(
                            "button",
                            {
                              key: opt.value,
                              staticClass: "net-transport-btn",
                              class: {
                                "is-selected":
                                  _vm.selectedTransport === opt.value,
                                "is-current":
                                  _vm.summary.transport === opt.value,
                                "is-advanced": opt.advanced,
                              },
                              style: { "--opt-color": opt.color },
                              attrs: {
                                type: "button",
                                disabled: _vm.applying,
                                title: opt.title,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.selectTransport(opt.value)
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    "x-small": "",
                                    color:
                                      _vm.selectedTransport === opt.value
                                        ? "white"
                                        : opt.color,
                                  },
                                },
                                [_vm._v(_vm._s(opt.icon))]
                              ),
                              _vm._v(" " + _vm._s(opt.label) + " "),
                              _vm.summary.transport === opt.value
                                ? _c("span", {
                                    staticClass: "net-transport-current",
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        }),
                        _c(
                          "button",
                          {
                            staticClass: "net-advanced-btn",
                            class: { "is-open": _vm.advancedOpen },
                            attrs: {
                              type: "button",
                              title: _vm.$t("yealink-net-advanced"),
                            },
                            on: {
                              click: function ($event) {
                                _vm.advancedOpen = !_vm.advancedOpen
                              },
                            },
                          },
                          [
                            _c("v-icon", { attrs: { "x-small": "" } }, [
                              _vm._v("mdi-tune-variant"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "net-switch-row net-stun-row",
                      class: { "is-disabled": _vm.selectedTransport === null },
                    },
                    [
                      _c("v-switch", {
                        staticClass: "net-stun-switch",
                        attrs: {
                          inset: "",
                          dense: "",
                          "hide-details": "",
                          color: "#16a34a",
                          disabled:
                            _vm.selectedTransport === null || _vm.applying,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _c("span", { staticClass: "net-stun-label" }, [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.$t("yealink-net-stun"))),
                                  ]),
                                  _c(
                                    "span",
                                    { staticClass: "net-stun-server" },
                                    [_vm._v(_vm._s(_vm.stunServer))]
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.stunEnabled,
                          callback: function ($$v) {
                            _vm.stunEnabled = $$v
                          },
                          expression: "stunEnabled",
                        },
                      }),
                      _vm.selectedTransport !== null
                        ? _c(
                            "span",
                            {
                              staticClass: "net-stun-default",
                              class: {
                                "is-override":
                                  _vm.stunEnabled !==
                                  _vm.defaultStunFor(_vm.selectedTransport),
                              },
                              attrs: {
                                title:
                                  _vm.stunEnabled !==
                                  _vm.defaultStunFor(_vm.selectedTransport)
                                    ? _vm.$t("yealink-net-stun-override")
                                    : _vm.defaultStunFor(_vm.selectedTransport)
                                    ? _vm.$t("yealink-net-stun-default-on", {
                                        transport: _vm.transportLabel(
                                          _vm.selectedTransport
                                        ),
                                      })
                                    : _vm.$t("yealink-net-stun-default-off", {
                                        transport: _vm.transportLabel(
                                          _vm.selectedTransport
                                        ),
                                      }),
                              },
                            },
                            [
                              _c("v-icon", { attrs: { "x-small": "" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.stunEnabled !==
                                      _vm.defaultStunFor(_vm.selectedTransport)
                                      ? "mdi-pencil"
                                      : "mdi-auto-fix"
                                  )
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.selectedTransport === 2
                        ? _c(
                            "span",
                            { staticClass: "net-tls-warn" },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-1",
                                  attrs: { "x-small": "", color: "#b91c1c" },
                                },
                                [_vm._v("mdi-flask-outline")]
                              ),
                              _vm._v(
                                _vm._s(_vm.$t("yealink-net-tls-unsupported")) +
                                  " "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "net-switch-row net-actions" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "white--text net-apply-btn",
                          attrs: {
                            small: "",
                            depressed: "",
                            color: "#00acc1",
                            disabled:
                              _vm.selectedTransport === null ||
                              !_vm.scan.total ||
                              _vm.applying ||
                              _vm.rescanCountdown !== null,
                            loading: _vm.applying,
                          },
                          on: {
                            click: function ($event) {
                              _vm.applyDialog = true
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { small: "", left: "" } }, [
                            _vm._v("mdi-cloud-upload"),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("yealink-net-apply", {
                                  count: _vm.scan.total,
                                })
                              ) +
                              " "
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "net-reboot-btn",
                          attrs: {
                            small: "",
                            outlined: "",
                            color: "#d97706",
                            disabled:
                              !_vm.onlineCount || _vm.rebooting || _vm.applying,
                            loading: _vm.rebooting,
                          },
                          on: {
                            click: function ($event) {
                              _vm.rebootDialog = true
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { small: "", left: "" } }, [
                            _vm._v("mdi-restart"),
                          ]),
                          _vm._v(
                            " " + _vm._s(_vm.$t("yealink-net-reboot-all")) + " "
                          ),
                          _c("span", { staticClass: "net-count-pill warn" }, [
                            _vm._v(_vm._s(_vm.onlineCount)),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.selectedTransport !== null
                    ? _c("div", { staticClass: "net-impact" }, [
                        _c(
                          "span",
                          { staticClass: "net-impact-item change" },
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "mr-1",
                                attrs: { "x-small": "", color: "#f59e0b" },
                              },
                              [_vm._v("mdi-swap-horizontal")]
                            ),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("yealink-net-impact-change", {
                                    count: _vm.impact.change,
                                  })
                                ) +
                                " "
                            ),
                          ],
                          1
                        ),
                        _c(
                          "span",
                          { staticClass: "net-impact-item same" },
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "mr-1",
                                attrs: { "x-small": "", color: "#16a34a" },
                              },
                              [_vm._v("mdi-check")]
                            ),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("yealink-net-impact-same", {
                                    count: _vm.impact.same,
                                  })
                                ) +
                                " "
                            ),
                          ],
                          1
                        ),
                        _vm.impact.offline
                          ? _c(
                              "span",
                              { staticClass: "net-impact-item offline" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-1",
                                    attrs: { "x-small": "", color: "#9ca3af" },
                                  },
                                  [_vm._v("mdi-power-plug-off")]
                                ),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("yealink-net-impact-offline", {
                                        count: _vm.impact.offline,
                                      })
                                    ) +
                                    " "
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm.applyResult
                ? _c(
                    "v-alert",
                    {
                      staticClass: "net-banner",
                      attrs: {
                        type: _vm.applyResult.failed ? "warning" : "success",
                        outlined: "",
                        dense: "",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-center flex-wrap net-banner-row",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column flex-grow-1" },
                            [
                              _c(
                                "span",
                                { staticClass: "text-body-2 font-weight-bold" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("yealink-net-apply-success", {
                                          pushed: _vm.applyResult.pushed,
                                          total: _vm.applyResult.total,
                                        })
                                      ) +
                                      " — " +
                                      _vm._s(
                                        _vm.transportLabel(
                                          _vm.applyResult.transport
                                        )
                                      ) +
                                      " · " +
                                      _vm._s(_vm.$t("yealink-net-stun")) +
                                      " " +
                                      _vm._s(
                                        _vm.applyResult.stun
                                          ? _vm.$t("yealink-net-stun-on")
                                          : _vm.$t("yealink-net-stun-off")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _vm._l(
                                _vm.applyResult.results.filter(
                                  (x) => x.result === "failed"
                                ),
                                function (r) {
                                  return _c(
                                    "span",
                                    {
                                      key: r.deviceId,
                                      staticClass: "text-caption error--text",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(r.name || r.mac) +
                                          ": " +
                                          _vm._s(r.error) +
                                          " "
                                      ),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                          _vm.rescanCountdown !== null
                            ? _c(
                                "div",
                                { staticClass: "net-countdown" },
                                [
                                  _c(
                                    "v-progress-circular",
                                    {
                                      attrs: {
                                        value:
                                          (_vm.rescanCountdown /
                                            _vm.rescanTotal) *
                                          100,
                                        rotate: -90,
                                        size: "30",
                                        width: "3",
                                        color: "#00acc1",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "net-countdown-num" },
                                        [_vm._v(_vm._s(_vm.rescanCountdown))]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "net-countdown-text" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("yealink-net-rescan-in", {
                                            seconds: _vm.rescanCountdown,
                                          })
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        "x-small": "",
                                        text: "",
                                        color: "#00acc1",
                                      },
                                      on: { click: _vm.runScan },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("yealink-net-rescan-now")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.rebootResult
                ? _c(
                    "v-alert",
                    {
                      staticClass: "net-banner",
                      attrs: {
                        type: _vm.rebootResult.failed ? "warning" : "success",
                        outlined: "",
                        dense: "",
                        dismissible: "",
                      },
                      on: {
                        input: function ($event) {
                          _vm.rebootResult = null
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "text-body-2 font-weight-bold" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("yealink-net-reboot-all-success", {
                                  rebooted: _vm.rebootResult.rebooted,
                                  skipped: _vm.rebootResult.skipped,
                                  failed: _vm.rebootResult.failed,
                                })
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.historyOpen
                ? _c("div", { staticClass: "net-history" }, [
                    _c(
                      "div",
                      { staticClass: "net-history-header" },
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "mr-1",
                            attrs: { small: "", color: "#5a6577" },
                          },
                          [_vm._v("mdi-history")]
                        ),
                        _c("span", { staticClass: "net-history-title" }, [
                          _vm._v(_vm._s(_vm.$t("yealink-net-history"))),
                        ]),
                        _vm.history.entryCount
                          ? _c("span", { staticClass: "net-history-count" }, [
                              _vm._v(_vm._s(_vm.history.entryCount)),
                            ])
                          : _vm._e(),
                        _vm.history.loading
                          ? _c("v-progress-circular", {
                              staticClass: "ml-2",
                              attrs: {
                                indeterminate: "",
                                size: "12",
                                width: "2",
                                color: "#00acc1",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    !_vm.history.loading && !_vm.history.entries.length
                      ? _c("div", { staticClass: "net-history-empty" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("yealink-net-history-empty")) +
                              " "
                          ),
                        ])
                      : _c(
                          "div",
                          { staticClass: "net-timeline" },
                          [
                            _vm._l(_vm.visibleHistory, function (entry) {
                              return _c(
                                "div",
                                {
                                  key: entry.id,
                                  staticClass: "net-entry",
                                  class: [
                                    `type-${entry.type}`,
                                    {
                                      "is-open": _vm.expandedEntries[entry.id],
                                    },
                                  ],
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "net-entry-dot" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            "x-small": "",
                                            color: "white",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.entryIcon(entry.type))
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "net-entry-body",
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleEntry(entry.id)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "net-entry-top" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "net-entry-title" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.entryTitle(entry))
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "net-entry-badges" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "net-mini-badge",
                                                  style: {
                                                    "--badge-color":
                                                      _vm.transportColor(
                                                        entry.transport
                                                      ),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.transportLabel(
                                                        entry.transport
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "net-mini-badge",
                                                  style: {
                                                    "--badge-color":
                                                      _vm.stunColor(entry.stun),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("yealink-net-stun")
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.stunLabel(
                                                          entry.stun
                                                        )
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "net-entry-meta" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "net-entry-date",
                                              attrs: {
                                                title: _vm.fromNow(entry.at),
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-1",
                                                  attrs: { "x-small": "" },
                                                },
                                                [_vm._v("mdi-clock-outline")]
                                              ),
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatDateTime(entry.at)
                                                ) + " "
                                              ),
                                            ],
                                            1
                                          ),
                                          entry.by
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "net-entry-by",
                                                  attrs: {
                                                    title: entry.by.email,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: { "x-small": "" },
                                                    },
                                                    [_vm._v("mdi-account")]
                                                  ),
                                                  _vm._v(
                                                    _vm._s(entry.by.name) + " "
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "net-entry-devices",
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-1",
                                                  attrs: { "x-small": "" },
                                                },
                                                [_vm._v("mdi-deskphone")]
                                              ),
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "yealink-net-history-phones",
                                                    {
                                                      count: (
                                                        entry.devices || []
                                                      ).length,
                                                    }
                                                  )
                                                ) + " "
                                              ),
                                            ],
                                            1
                                          ),
                                          entry.changes && entry.changes.length
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "net-entry-changes",
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: { "x-small": "" },
                                                    },
                                                    [_vm._v("mdi-delta")]
                                                  ),
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "yealink-net-history-changes",
                                                        {
                                                          count:
                                                            entry.changes
                                                              .length,
                                                        }
                                                      )
                                                    ) + " "
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "net-entry-chevron",
                                              attrs: { "x-small": "" },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.expandedEntries[entry.id]
                                                    ? "mdi-chevron-up"
                                                    : "mdi-chevron-down"
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.expandedEntries[entry.id]
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "net-entry-details",
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                },
                                              },
                                            },
                                            [
                                              entry.changes &&
                                              entry.changes.length
                                                ? _vm._l(
                                                    entry.changes,
                                                    function (c) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: c.deviceId,
                                                          staticClass:
                                                            "net-change-row",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "net-change-name",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  c.name ||
                                                                    c.mac
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "net-change-from",
                                                            },
                                                            [
                                                              c.from
                                                                ? [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.transportLabel(
                                                                          c.from
                                                                            .transport
                                                                        )
                                                                      ) +
                                                                        " · " +
                                                                        _vm._s(
                                                                          _vm.stunShort(
                                                                            c
                                                                              .from
                                                                              .stun
                                                                          )
                                                                        )
                                                                    ),
                                                                  ]
                                                                : [_vm._v("—")],
                                                            ],
                                                            2
                                                          ),
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "mx-1",
                                                              attrs: {
                                                                "x-small": "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-arrow-right"
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "net-change-to",
                                                              style: {
                                                                color:
                                                                  _vm.transportColor(
                                                                    c.to
                                                                      .transport
                                                                  ),
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.transportLabel(
                                                                    c.to
                                                                      .transport
                                                                  )
                                                                ) +
                                                                  " · " +
                                                                  _vm._s(
                                                                    _vm.stunShort(
                                                                      c.to.stun
                                                                    )
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                          c.result
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "net-change-result",
                                                                  class:
                                                                    c.result,
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      c.result ===
                                                                        "pushed"
                                                                        ? _vm.$t(
                                                                            "yealink-net-history-pushed"
                                                                          )
                                                                        : _vm.$t(
                                                                            "yealink-net-history-failed"
                                                                          )
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  )
                                                : _vm._l(
                                                    entry.devices,
                                                    function (d) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: d.deviceId,
                                                          staticClass:
                                                            "net-change-row",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "net-change-name",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  d.name ||
                                                                    d.mac
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "net-change-to",
                                                              style: {
                                                                color:
                                                                  _vm.transportColor(
                                                                    d.transport
                                                                  ),
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.transportLabel(
                                                                    d.transport
                                                                  )
                                                                ) +
                                                                  " · " +
                                                                  _vm._s(
                                                                    _vm.stunShort(
                                                                      d.stun
                                                                    )
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            _vm.history.entries.length > _vm.historyLimit
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "mt-1",
                                    attrs: {
                                      "x-small": "",
                                      text: "",
                                      color: "#00acc1",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.showAllHistory = !_vm.showAllHistory
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.showAllHistory
                                            ? _vm.$t(
                                                "yealink-net-history-show-less"
                                              )
                                            : _vm.$t(
                                                "yealink-net-history-show-all",
                                                {
                                                  count:
                                                    _vm.history.entries.length,
                                                }
                                              )
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "520",
            persistent: "",
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.applyDialog,
            callback: function ($$v) {
              _vm.applyDialog = $$v
            },
            expression: "applyDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "cyan white--text" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-2", attrs: { color: "white" } },
                    [_vm._v("mdi-swap-horizontal-bold")]
                  ),
                  _vm._v(" " + _vm._s(_vm.$t("yealink-net-apply-title")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "", dark: "" },
                      on: {
                        click: function ($event) {
                          _vm.applyDialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-card-text", { staticClass: "pt-4" }, [
                _c("div", { staticClass: "net-confirm-target" }, [
                  _c(
                    "span",
                    {
                      staticClass: "net-confirm-big",
                      style: {
                        color: _vm.transportColor(_vm.selectedTransport),
                      },
                    },
                    [_vm._v(_vm._s(_vm.transportLabel(_vm.selectedTransport)))]
                  ),
                  _c("span", { staticClass: "net-confirm-plus" }, [
                    _vm._v("+"),
                  ]),
                  _c(
                    "span",
                    {
                      staticClass: "net-confirm-big",
                      style: { color: _vm.stunColor(_vm.stunEnabled) },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("yealink-net-stun")) +
                          " " +
                          _vm._s(_vm.stunLabel(_vm.stunEnabled))
                      ),
                    ]
                  ),
                ]),
                _c("p", { staticClass: "mb-2" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("yealink-net-apply-confirm", {
                          site: _vm.scan ? _vm.scan.siteName : "",
                          transport: _vm.transportLabel(_vm.selectedTransport),
                          stun: _vm.stunLabel(_vm.stunEnabled),
                        })
                      ) +
                      " "
                  ),
                ]),
                _vm.selectedTransport === 2
                  ? _c(
                      "p",
                      { staticClass: "text-caption mb-2" },
                      [
                        _c(
                          "v-icon",
                          { staticClass: "mr-1", attrs: { "x-small": "" } },
                          [_vm._v("mdi-information-outline")]
                        ),
                        _vm._v(
                          _vm._s(_vm.$t("yealink-net-apply-tls-note")) + " "
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c("div", { staticClass: "net-impact net-impact-dialog" }, [
                  _c("span", { staticClass: "net-impact-item change" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("yealink-net-impact-change", {
                          count: _vm.impact.change,
                        })
                      )
                    ),
                  ]),
                  _c("span", { staticClass: "net-impact-item same" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("yealink-net-impact-same", {
                          count: _vm.impact.same,
                        })
                      )
                    ),
                  ]),
                  _vm.impact.offline
                    ? _c("span", { staticClass: "net-impact-item offline" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("yealink-net-impact-offline", {
                              count: _vm.impact.offline,
                            })
                          )
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.applyDialog = false
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "cyan", dark: "", loading: _vm.applying },
                      on: { click: _vm.confirmApply },
                    },
                    [
                      _c("v-icon", { attrs: { left: "", small: "" } }, [
                        _vm._v("mdi-cloud-upload"),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("yealink-net-apply", {
                              count: _vm.scan ? _vm.scan.total : 0,
                            })
                          ) +
                          " "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "460",
            persistent: "",
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.rebootDialog,
            callback: function ($$v) {
              _vm.rebootDialog = $$v
            },
            expression: "rebootDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "warning white--text" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-2", attrs: { color: "white" } },
                    [_vm._v("mdi-restart")]
                  ),
                  _vm._v(
                    " " + _vm._s(_vm.$t("yealink-net-reboot-all-title")) + " "
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "", dark: "" },
                      on: {
                        click: function ($event) {
                          _vm.rebootDialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pt-4" },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "mb-3",
                      attrs: { type: "warning", outlined: "", dense: "" },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("yealink-net-reboot-all-confirm", {
                              count: _vm.onlineCount,
                              site: _vm.scan ? _vm.scan.siteName : "",
                            })
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.rebootDialog = false
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "warning", loading: _vm.rebooting },
                      on: { click: _vm.confirmReboot },
                    },
                    [
                      _c("v-icon", { attrs: { left: "", small: "" } }, [
                        _vm._v("mdi-restart"),
                      ]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("yealink-net-reboot-all")) + " "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }